























import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

import Pagination from './Pagination.vue'

Vue.component('pagination', Pagination)

@Component
export default class OffsetPagination extends Vue {
  currentPage!: number

  @Prop({required: true})
  pagination: any

  @Prop({required:false,default:true})
  showPrefix!: boolean

  @Prop({default: false})
  disabled!: boolean

  // Computed properties are getters/setters
  get totalPages() {
    return Math.ceil(this.pagination.total / this.pagination.max)
  }

  mounted() {
    this.currentPage = this.pageNumberForOffset(this.pagination.offset)
  }

  changePage (page: number) {
      this.$emit('change', this.pageOffset(page))
  }
  pageOffset (page: number) {
    return (page - 1) * this.pagination.max
  }

  pageNumberForOffset(offset: number) {
    return 1 + (offset / this.pagination.max)
  }
}
